/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payor/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import Patient from './Patient/index'
import Person from './Person/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Payor({
  children,
  viewPath = "/DesignSystem/LedgerPaymentAccount/PersonPaymentAccount/Payor"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let paymentAccountPersonPaymentAccountPayerPersonPatientValueData = fromData.useDataFormat({ viewPath,
context: 'payment_account',
path: 'person_payment_account.payer_person.patient',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: paymentAccountPersonPaymentAccountPayerPersonPatientValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Person'}>
<Person
  viewPath={`${viewPath}/Person`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Patient'}>
<Patient
  viewPath={`${viewPath}/Patient`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}